// import store from '@/store/index.js'
// let dic = store.state.dic;
import {
    getOrgOptions,
} from "@/libs/searchSelect.js";
export default function Configs(that) {

    const searchItems = [
        {
            label: "姓名",
            span: 4,
            placeholder: '请输入姓名',
            model: "studentName",
        },
        {
            label: "学院",
            span: 5,
            type: 'select',
            model: "collegeId",
            options: [],
            clearable: true,
            change(data) {
                // console.log(data)
                let params = {
                    parentId: data,
                    type: 'department'
                }
                that.searchItems[2].options = [];
                that.searchItems[3].options = [];
                that.searchItems[4].options = [];
                that.pageParams.departmentId = "";
                that.pageParams.majorId = "";
                that.pageParams.classId = "";
                if (data) {
                    getOrgOptions(that, params, 2, null)
                }
            },
        },
        {
            label: "系别",
            span: 5,
            type: 'select',
            model: "departmentId",
            options: [],
            clearable: true,
            change(data) {
                let params = {
                    parentId: data,
                    type: 'major'
                }
                that.searchItems[3].options = [];
                that.searchItems[4].options = [];
                that.pageParams.majorId = "";
                that.pageParams.classId = "";
                if (data) {
                    getOrgOptions(that, params, 3, null)
                }
            },
        },
        {
            label: "专业",
            span: 5,
            type: 'select',
            model: "majorId",
            options: [],
            clearable: true,
            change(data) {
                console.log(data)
                let params = {
                    parentId: data,
                    type: 'class'
                }
                that.searchItems[4].options = [];
                that.pageParams.classId = '';
                if (data) {
                    getOrgOptions(that, params, 4, null)
                }
            },
        },
        {
            label: "班级",
            span: 5,
            type: 'select',
            model: "classId",
            options: [],
            clearable: true,
        },
        {
            label: "报到状态",
            span: 6,
            placeholder: '请选择报到状态',
            model: "99",
            type: "select",
        },
        {
            label: "所属地区(模糊匹配省市县及详细地址)",
            span: 18,
            placeholder: '请输入',
            model: "99",
            labelWidth: '280px'
        },

    ]
    const tableColumns = [
        {
            label: "打印报到单",
            prop: "11",
            align: "center",
            show: true
        },
        {
            label: "姓名",
            prop: "22",
            align: "center",
            show: true
        },
        {
            label: "报到状态",
            prop: "33",
            align: "center",
            show: true
        },
        {
            label: "身份证号",
            prop: "44",
            align: "center",
            show: true
        },
        {
            label: "学院",
            prop: "55",
            align: "center",
            show: true
        },
        {
            label: "系别",
            prop: "66",
            align: "center",
            show: true
        },
        {
            label: "专业",
            prop: "77",
            align: "center",
            show: true
        },
        {
            label: "班级",
            prop: "88",
            align: "center",
            show: true
        },
        {
            label: "民族",
            prop: "99",
            align: "center",
            // width:'150px',
            show: true
        },
        {
            label: "出生日期",
            prop: "100",
            align: "center",
            show: true
        },
        {
            label: "联系方式",
            prop: "101",
            align: "center",
            // width:'150px',
            show: true
        },
        {
            label: "邮编",
            prop: "101",
            align: "center",
            // width:'150px',
            show: true
        },
        {
            label: "所在省",
            prop: "101",
            align: "center",
            // width:'150px',
            show: true
        },
        {
            label: "所在市",
            prop: "101",
            align: "center",
            // width:'150px',
            show: true
        },
        {
            label: "所在县",
            prop: "101",
            align: "center",
            // width:'150px',
            show: true
        },
        {
            label: "详细地址",
            prop: "101",
            align: "center",
            // width:'150px',
            show: true
        },
        // {
        //     label: "操作",
        //     name: "custom",
        //     align: "center",
        //     width:'260px',
        //     show:true
        //   }
    ]

    return {
        searchItems,
        tableColumns
    }
}
